import { ModuleType } from 'global-services/constants/OhsObject';
import OhsQrCodeRecord from 'qr-code/models/OhsQrCodeRecord';

import OhsConfigurations from './OhsConfigurations';

export default function manipulateGuestUserConfig(
  configs: OhsConfigurations,
  qrCodeDataConfig: OhsQrCodeRecord
): void {
  if (!qrCodeDataConfig || !qrCodeDataConfig._id || !configs) return;

  if (
    qrCodeDataConfig.moduleType === ModuleType.Incident &&
    qrCodeDataConfig.eventType === 'create' &&
    configs.incident
  ) {
    const incidentConfig = configs.incident;

    const originalCategoryList = incidentConfig.CREATE_INCIDENT_CATEGORY_LIST || [];
    const qrCategories = qrCodeDataConfig.categories || [];

    if (Array.isArray(qrCategories)) {
      const catListMap = new Map(originalCategoryList.map((cat) => [cat.title, cat]));

      const mappedCategories = qrCategories.map((categoryName: string) => {
        return (
          catListMap.get(categoryName) || {
            title: categoryName,
            description: '',
            options: [],
            cusvals: null,
          }
        );
      });

      incidentConfig.CREATE_INCIDENT_CATEGORY_LIST = mappedCategories;
    }

    const qrSignature = qrCodeDataConfig.signature ?? false;
    if (qrSignature === false) {
      incidentConfig.CREATE_INCIDENT_HAND_SIGNATURES = '0';
    }

    const originalConfidential = incidentConfig.CONFIDENTIAL_INCIDENTS ?? false;
    const qrConfidential = qrCodeDataConfig.confidential ?? false;
    incidentConfig.CONFIDENTIAL_INCIDENTS = qrConfidential && originalConfidential;

    if (incidentConfig.CREATE_INCIDENT_INJURED_PERSON_LOOKUP) {
      incidentConfig.CREATE_INCIDENT_INJURED_PERSON_LOOKUP.scope = '';
    }
  }
}
